import { Option, none, isNone, some } from 'fp-ts/lib/Option';

export default interface DeleteWidgetCriteria {
    dashboardId: string;
    widgetId: string;
}

class DeleteWidgetCriteriaImpl implements DeleteWidgetCriteria {
    constructor(readonly dashboardId: string, readonly widgetId: string) {}
}

export class DeleteWidgetCriteriaBuilder {
    private dashboardId: Option<string> = none;

    private widgetId: Option<string> = none;

    static create = (): DeleteWidgetCriteriaBuilder => new DeleteWidgetCriteriaBuilder();

    withDashboardId = (id: string): DeleteWidgetCriteriaBuilder => {
        this.dashboardId = some(id);
        return this;
    };

    withWidgetId = (id: string): DeleteWidgetCriteriaBuilder => {
        this.widgetId = some(id);
        return this;
    };

    build = (): DeleteWidgetCriteria => {
        if (isNone(this.dashboardId)) {
            throw new ReferenceError('Undefined dashboard id');
        }
        if (isNone(this.widgetId)) {
            throw new ReferenceError('Undefined widget id');
        }

        return new DeleteWidgetCriteriaImpl(this.dashboardId.value, this.widgetId.value);
    };
}
